
import dateFormat from 'vux/src/tools/date/format.js'

import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import {EncryptString} from '../../../static/js/xintong/AESUtils.js'
export default {
data(){
return {
typetitle:'',
typevalue:'',
lookArry:[]
}
},
methods:{
link(href){
let parmaObj = {identyId: this.$route.query.identyId,name:this.$route.query.name};
window.location.href = href + '?sign=' +EncryptString(JSON.stringify(parmaObj)) +'&t='+ (new Date()).valueOf();
},
getdata(){
fetch('get',urlConfig.getauditrecord + this.$route.query.identyId).then(response => {

this.lookArry = response;
for(let i =0;i< this.lookArry.length;i++){
this.lookArry[i].CREATED_DATE = this.timestampToTime(this.lookArry[i].CREATED_DATE);
}
this.getstatus();
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {


})
},
getstatus(){
fetch('get',urlConfig.GetPersonInfoId +'?sfzh=' + this.$route.query.identyId).then(response => {

fetch('get',urlConfig.patientBasicInfosGet + '?personInfoId=' +response.personInfoId).then(response => {

if(response.firstDate == null){
this.typetitle = '就诊状态';
this.typevalue = '未到院';
}else{
if(new Date(dateFormat(new Date(), 'YYYY-MM-DD')) >= new Date(response.firstDate)){
this.typetitle = '就诊状态';
this.typevalue = '已到院 到院日期：' + response.firstDate;
}else{
this.typetitle = '计划到院日期';
this.typevalue = response.firstDate;
}
}

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {


})

}).catch(error => {


})
},
timestampToTime(timestamp) {
var date = new Date(timestamp);
var Y = date.getFullYear() + '-';
var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
var D = date.getDate();
/*  var h = date.getHours() + ':';
var m = date.getMinutes() + ':';
var s = date.getSeconds();*/
return Y + M + D ;
}  //时间戳
},
components: {
Cell, Group,XHeader
},
mounted() {
document.title = '更多就诊信息';
this.$store.commit('updateLoadingStatus',{isLoading:true});
getken(this.getdata);
}
}



// WEBPACK FOOTER //
// ./src/project/internetHospital/lookIndex.vue